import Vue from 'vue';

interface FormField {
	value: any;
}

interface Form {
	username: FormField;
	apartment: FormField;
	phone: FormField;
	email: FormField;
}

export default Vue.extend({
	data () {
		return {
			dialog_admin: false,
			admin_in_dialog: false,
			dialog_ch: false,
			ch_in_dialog:false,
			check: ['white'],

			la_user_tabs: null,
			la_admin_tabs: null,

			form: {
				username: { value: null },
				apartment: { value: null },
				phone: { value: null },
				email: { value: null },
			} as Form
		}
	},
	methods:
		{
			// 더 이상 인자를 받지 않습니다.
			HANDLE_SEND_SLACK() {
				if (!this.isPrivacyAgreed()) return;
				if (!this.areRequiredFieldsFilled()) return;

				const content = this.createContentMessage();
				this.sendSlackMessage(content);
			},

			isPrivacyAgreed(): boolean {
				if (this.check.length < 2) {
					// i18n 키를 사용하여 토스트 메시지를 표시합니다.
					this.$toasted.show(this.$t('LaboratoryPage.toasts.agreePrivacy') as string);
					return false;
				}
				return true;
			},

			areRequiredFieldsFilled(): boolean {
				const requiredFields: (keyof Form)[] = ['username', 'apartment', 'email'];
				// 폼 필드 이름과 i18n 키를 매핑합니다.
				// FIX: Explicitly type `labelKeys` and include all keys from `Form` to ensure type safety.
				const labelKeys: Record<keyof Form, string> = {
					username: 'LaboratoryPage.manualDialog.form.name',
					apartment: 'LaboratoryPage.manualDialog.form.apartment',
					email: 'LaboratoryPage.manualDialog.form.email',
					phone: 'LaboratoryPage.manualDialog.form.phone' // Added to match the Form type
				};

				for (const key of requiredFields) {
					// null 또는 빈 문자열을 확인합니다.
					if (!this.form[key].value) {
						const fieldName = this.$t(labelKeys[key]) as string;
						// i18n 키와 인자를 사용하여 동적 메시지를 생성합니다.
						this.$toasted.show(this.$t('LaboratoryPage.toasts.fillField', { field: fieldName }) as string);
						return false;
					}
				}
				return true;
			},

			createContentMessage(): string {
				// i18n 키를 사용하여 메시지 타입을 가져옵니다.
				const type = this.$t('LaboratoryPage.slack.manualRequestType') as string;
				const title = this.$t('LaboratoryPage.slack.requestMessageTitle', { type: type }) as string;
				const contentArr = [title];

				// 폼 필드 이름과 i18n 키를 매핑합니다.
				const labelKeys: Record<keyof Form, string> = {
					username: 'LaboratoryPage.manualDialog.form.name',
					apartment: 'LaboratoryPage.manualDialog.form.apartment',
					phone: 'LaboratoryPage.manualDialog.form.phone',
					email: 'LaboratoryPage.manualDialog.form.email'
				};

				Object.keys(this.form).forEach(key => {
					const typedKey = key as keyof Form;
					const value = this.form[typedKey].value;

					// 값이 있는 필드만 메시지에 추가합니다.
					if (value) {
						const label = this.$t(labelKeys[typedKey]) as string;
						contentArr.push(this._.sprintf("%s: %s", [label, value]));
					}
				});

				return contentArr.join('\n');
			},

			resetFormValues() {
				Object.keys(this.form).forEach(key => {
					const typedKey = key as keyof Form;
					this.form[typedKey].value = null;
				});
				this.check = ['white'];
			},

			sendSlackMessage(content: string) {
				this.$aws.lambda.invoke(
					process.env.VUE_APP_AWS_LAMBDA_CREATE_MESSAGE_SLACK as string,
					'RequestResponse',
					JSON.stringify({
						action: 'OFFICIAL',
						content: content
					})
				).then( res => {
					this.resetFormValues();
					this.ch_in_dialog = true;
				});
			}
		},
	computed:
		{
			usePrivacy() {
				return process.env.VUE_APP_PRIVACY;
			}
		}
});